import {
  CREATE_ACCOUNT_BANK,
  CREATE_ACCOUNT_BANK_FAIL,
  CREATE_ACCOUNT_BANK_SUCCESS,
  CREATE_CUSTOMER_INVOICE,
  CREATE_CUSTOMER_INVOICE_FAIL,
  CREATE_CUSTOMER_INVOICE_SUCCESS,
  DELETE_CUSTOMER_INVOICE,
  DELETE_CUSTOMER_INVOICE_FAIL,
  DELETE_CUSTOMER_INVOICE_SUCCESS,
  EDIT_CUSTOMER_INVOICE,
  EDIT_CUSTOMER_INVOICE_FAIL,
  EDIT_CUSTOMER_INVOICE_SUCCESS,
  GET_ALL_ACCOUNT_BANK,
  GET_ALL_ACCOUNT_BANK_FAIL,
  GET_ALL_ACCOUNT_BANK_SUCCESS,
  GET_ALL_CUSTOMER_INVOICE,
  GET_ALL_CUSTOMER_INVOICE_FAIL,
  GET_ALL_CUSTOMER_INVOICE_SUCCESS,
  GET_DETAIL_CUSTOMER_INVOICE,
  GET_DETAIL_CUSTOMER_INVOICE_FAIL,
  GET_DETAIL_CUSTOMER_INVOICE_SUCCESS,
  GET_LIST_CUSTOMER_INVOICE,
  GET_LIST_CUSTOMER_INVOICE_FAIL,
  GET_LIST_CUSTOMER_INVOICE_SUCCESS,
  RESET_CREATE_ACCOUNT_BANK,
  RESET_CREATE_CUSTOMER_INVOICE,
  RESET_DELETE_CUSTOMER_INVOICE,
  RESET_EDIT_CUSTOMER_INVOICE,
  RESET_LIST_CUSTOMER_INVOICE,
  SET_COLUMN_VISIBLE_CUSTOMER_INVOICE,
} from "./actionTypes";

const INIT_STATE = {
  type: null,
  // Khách hàng
  customer: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  detailCustomer: {
    loading: false,
    data: null,
    error: null,
  },
  createCustomer: {
    loading: false,
    data: null,
    error: null,
  },
  editCustomer: {
    loading: false,
    data: null,
    error: null,
  },
  deleteCustomer: {
    loading: false,
    data: null,
    error: null,
  },
  createAccountBankData: {
    loading: false,
    data: null,
    error: null,
  },
  listVat: [],

  listAllCustomer: [],
  loadListAllCustomer: false,

  listAllAccountBank: [],
  loadListAllAccountBank: false,
};

const customerInvoice = (state = INIT_STATE, action) => {
  const curCustomer = state.customer;
  switch (action.type) {
    // Khách hàng
    case GET_LIST_CUSTOMER_INVOICE:
      return {
        ...state,
        customer: {
          ...curCustomer,
          loading: true,
          //   params: action.params,
        },
      };
    case GET_LIST_CUSTOMER_INVOICE_SUCCESS:
      return {
        ...state,
        customer: {
          ...curCustomer,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_CUSTOMER_INVOICE_FAIL:
      return {
        ...state,
        customer: {
          ...curCustomer,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_CUSTOMER_INVOICE:
      return {
        ...state,
        customer: {
          ...curCustomer,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Detail Khách hàng
    case GET_DETAIL_CUSTOMER_INVOICE:
      return {
        ...state,
        detailCustomer: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DETAIL_CUSTOMER_INVOICE_SUCCESS:
      return {
        ...state,
        detailCustomer: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case GET_DETAIL_CUSTOMER_INVOICE_FAIL:
      return {
        ...state,
        detailCustomer: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    // Tạo khách hàng
    case CREATE_CUSTOMER_INVOICE:
      return {
        ...state,
        createCustomer: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_CUSTOMER_INVOICE_SUCCESS:
      return {
        ...state,
        createCustomer: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_CUSTOMER_INVOICE_FAIL:
      return {
        ...state,
        createCustomer: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_CUSTOMER_INVOICE:
      return {
        ...state,
        createCustomer: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Cập nhật khách hàng
    case EDIT_CUSTOMER_INVOICE:
      return {
        ...state,
        editCustomer: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case EDIT_CUSTOMER_INVOICE_SUCCESS:
      return {
        ...state,
        editCustomer: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case EDIT_CUSTOMER_INVOICE_FAIL:
      return {
        ...state,
        editCustomer: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_EDIT_CUSTOMER_INVOICE:
      return {
        ...state,
        editCustomer: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Xóa khách hàng
    case DELETE_CUSTOMER_INVOICE:
      return {
        ...state,
        deleteCustomer: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case DELETE_CUSTOMER_INVOICE_SUCCESS:
      return {
        ...state,
        deleteCustomer: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case DELETE_CUSTOMER_INVOICE_FAIL:
      return {
        ...state,
        deleteCustomer: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_DELETE_CUSTOMER_INVOICE:
      return {
        ...state,
        deleteCustomer: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // GET_ALL_CUSTOMER_INVOICE
    case GET_ALL_CUSTOMER_INVOICE:
      return {
        ...state,
        listAllCustomer: [],
        loadListAllCustomer: true,
      };
    case GET_ALL_CUSTOMER_INVOICE_SUCCESS:
      return {
        ...state,
        listAllCustomer: action.data,
        loadListAllCustomer: false,
      };

    case GET_ALL_CUSTOMER_INVOICE_FAIL:
      return {
        ...state,
        listAllCustomer: [],
        loadListAllCustomer: false,
      };
    // Tạo tài khoản ngân hàng
    case CREATE_ACCOUNT_BANK:
      return {
        ...state,
        createAccountBankData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_ACCOUNT_BANK_SUCCESS:
      return {
        ...state,
        createAccountBankData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_ACCOUNT_BANK_FAIL:
      return {
        ...state,
        createAccountBankData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_ACCOUNT_BANK:
      return {
        ...state,
        createAccountBankData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // GET_ALL_CUSTOMER_INVOICE
    case GET_ALL_ACCOUNT_BANK:
      return {
        ...state,
        listAllAccountBank: [],
        loadListAllAccountBank: true,
      };
    case GET_ALL_ACCOUNT_BANK_SUCCESS:
      return {
        ...state,
        listAllAccountBank: action.data,
        loadListAllAccountBank: false,
      };

    case GET_ALL_ACCOUNT_BANK_FAIL:
      return {
        ...state,
        listAllAccountBank: [],
        loadListAllAccountBank: false,
      };
    // Set column
    case SET_COLUMN_VISIBLE_CUSTOMER_INVOICE:
      curCustomer.columnsVisible[action.field] = action.value;
      return {
        ...state,
        customer: {
          ...curCustomer,
        },
      };
    default:
      return state;
  }
};

export default customerInvoice;
